var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.694 9.50116V18.0043H3.08887V9.50116",
    fill: "#32A0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.694 9.50116V18.0043H3.08887V9.50116",
    stroke: "#32A0FF",
    strokeWidth: 1.4481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3316 5.25113H1.3252V9.50272H18.3316V5.25113Z",
    fill: "#32A0FF",
    stroke: "#32A0FF",
    strokeWidth: 1.4481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89266 5.24903H6.06623C5.50243 5.24903 4.96173 5.02506 4.56306 4.6264C4.1644 4.22773 3.94043 3.68703 3.94043 3.12323C3.94043 2.55944 4.1644 2.01873 4.56306 1.62007C4.96173 1.2214 5.50243 0.997437 6.06623 0.997437C9.04234 0.997437 9.89266 5.24903 9.89266 5.24903Z",
    stroke: "#141314",
    strokeWidth: 1.67802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8916 5.24863H13.718C14.2818 5.24863 14.8225 5.02467 15.2212 4.626C15.6199 4.22734 15.8438 3.68663 15.8438 3.12284C15.8438 2.55904 15.6199 2.01834 15.2212 1.61967C14.8225 1.22101 14.2818 0.99704 13.718 0.99704C10.7419 0.99704 9.8916 5.24863 9.8916 5.24863Z",
    stroke: "#141314",
    strokeWidth: 1.67802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91992 5.82898L9.91992 18.4154",
    stroke: "#141314",
    strokeWidth: 1.67802
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.c5413a5c4a6666aca59a84bc633614b4.svg";
export { ForwardRef as ReactComponent };